export enum ContractsWorkflowType {
  GENERAL = 1,
  YES_NO_QUESTIONNAIRE = 2,
  CHECKLIST = 3
}
